export function packageJson() {
  return `{
  "type": "module"
}
`;
}
